import React from "react";
import styles from "./render-checkbox.module.css";

export const uncheckedCheckboxIcon = <span className={styles.iconBox} />;

export const checkedCheckboxIcon = (
	<span className={styles.iconBox}>
		<svg width="9" height="7" viewBox="0 0 9 7" fill="none" aria-hidden>
			<path
				d="M1 3.5L3.2 5.7L8 1"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</svg>
	</span>
);

/** Partial selection: square with horizontal dash */
export const indeterminateCheckboxIcon = (
	<span className={styles.iconBox}>
		<svg width="8" height="2" viewBox="0 0 8 2" fill="none" aria-hidden>
			<path
				d="M0 1H8"
				strokeWidth="1.5"
				strokeLinecap="round"
			/>
		</svg>
	</span>
);
